import './messengerChatReveal.css';

const CHAT_REVEAL_ASSET =
  '/assets/messenger/joe-galaxy-chat-reveal.png';

export default function MessengerChatReveal({
  assetSrc = CHAT_REVEAL_ASSET,
  label = 'Loading conversation',
}) {
  return (
    <div className="messengerChatReveal" role="status" aria-label={label}>
      <div className="messengerChatReveal__logoWrap">
        <img
          className="messengerChatReveal__logo"
          src={assetSrc}
          alt=""
          aria-hidden="true"
          draggable="false"
          loading="eager"
          decoding="async"
          fetchpriority="high"
        />
      </div>
      <span className="messengerChatReveal__srOnly">{label}</span>
    </div>
  );
}
